import type { NoteStr } from '@tunasong/music-lib'
import { EasyScore, NoteLib } from '@tunasong/music-lib'

export const noteToMidiNumber = (noteStr: NoteStr, defaultOctave = 4): number => {
  const { octave = defaultOctave, note } = EasyScore.parseEvent(noteStr, defaultOctave)

  const index = NoteLib.getNoteChromaticIndex(note)

  return index + (octave + 1) * 12
}
